/**
 * InternalUserSelector
 * Dropdown for assigning a task (work order or project) to an internal user.
 * Shared by AssignWorkOrderModal and AssignProjectModal.
 */
import React from 'react';
import { Form } from 'react-bootstrap';
import { Userprofile } from '../Helpers/UsersContext';

interface InternalUserSelectorProps {
    users: Userprofile[];
    value: string;            // selected UID, or '' for unassigned
    onChange: (uid: string) => void;
    disabled?: boolean;
    /** Label for the empty option */
    unassignedLabel?: string;
    /** UIDs already added — shown disabled with "(redan tilldelad)" for multi-add. */
    disabledIds?: string[];
}

const InternalUserSelector: React.FC<InternalUserSelectorProps> = ({
    users,
    value,
    onChange,
    disabled = false,
    unassignedLabel = 'Otilldelad (öppen för alla)',
    disabledIds = [],
}) => (
    <Form.Select
        value={value}
        onChange={(e) => onChange(e.target.value)}
        disabled={disabled}
    >
        <option value="">{unassignedLabel}</option>
        {users.map((user) => {
            const alreadyAdded = disabledIds.includes(user.key);
            return (
                <option key={user.key} value={user.key} disabled={alreadyAdded}>
                    {user.name || user.email}{alreadyAdded ? ' (redan tilldelad)' : ''}
                </option>
            );
        })}
    </Form.Select>
);

export default InternalUserSelector;
